import type { StatusResponse } from '../../../shared/api.js';
import { Badge, VarList } from './Overview';

/** Database and chat agent state; a section of Settings. */
export function SystemSection({ status }: { status: StatusResponse }) {
  const { calendar, agent } = status;
  return (
    <section>
      <h2>Система</h2>
      <div className="grid">
        <article className="card">
          <header className="card__header">
            <h3>База данных</h3>
            <Badge ok={calendar.db.ok}>{calendar.db.ok ? 'Работает' : 'Недоступна'}</Badge>
          </header>
          {calendar.db.ok ? (
            <dl className="facts">
              <dt>Движок</dt>
              <dd>{calendar.db.backend === 'postgres' ? 'PostgreSQL' : 'PGlite (встроенный)'}</dd>
              <dt>Где</dt>
              <dd>
                <code className="break">{calendar.db.location}</code>
              </dd>
            </dl>
          ) : (
            <p className="text-error">{calendar.db.error}</p>
          )}
        </article>

        <article className="card">
          <header className="card__header">
            <h3>Чат-агент</h3>
            <Badge ok={agent.configured}>{agent.configured ? 'Включён' : 'Выключен'}</Badge>
          </header>
          {agent.configured ? (
            <dl className="facts">
              <dt>Модель</dt>
              <dd>
                <code>{agent.model}</code>
              </dd>
              <dt>Активных сессий</dt>
              <dd>{agent.activeSessions}</dd>
            </dl>
          ) : (
            <p className="muted">Нужен ключ Anthropic API:</p>
          )}
          <VarList missing={agent.missing} invalid={agent.invalid} />
        </article>
      </div>
      <p className="muted small">Версия {calendar.version}.</p>
    </section>
  );
}
